import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

import {
    FormatDate
} from '../../../../../libraries/Tool';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="comment">
                1.&nbsp;<span className="material-symbols-outlined">tag</span>&nbsp;{translate('comment')}
            </Typography>
            <p><strong>{translate('comment')}</strong> は、スクリプトの意味に注釈を付けて読みやすくするために使用されます。</p>

            <Typography variant="h5" gutterBottom id="setvariable">
                2.&nbsp;<span className="material-symbols-outlined">save</span>&nbsp;{translate('setvariable')}
            </Typography>
            <p><strong>{translate('setvariable')}</strong> は値をいれておける入れ物です。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>設定した変数の値の保存先です。</td>
                                <td>$variableName_1</td>
                            </tr>
                            <tr>
                                <td>{translate('value')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="any" />
                                </td>
                                <td>設定したい値です。</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="any" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <p>たとえば、「今日の日付」の値を保存のため、出力キー  <strong>{translate('outputkey')}</strong> <strong>$todayIs</strong>  を作成します。</p>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$todayIs</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>Value</span>
                            <div>Today is</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>Today is</div>
                        </div>
                    </div>
                    <p>事前定義された関数と出力キー <strong>Output keys</strong>を組み合わせて計算を指定できます。</p>
                    <p>たとえば、"今日は"<strong>$todayIs</strong>の文字と今日の日付の値を保存のため、上記のtodayIs変数を含めて出力キー<strong>the Output key </strong>  <strong>$result</strong> を作成します。</p>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$result</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>Value</span>
                            <div><span className='parameter-fx'>fx(<span className='parameter-fx-value'>$todayIs + " " + GetCurrentDate(7 , "YYYY-MM-DD")</span>)</span></div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>{"Today is " + FormatDate(new Date(), "yyyy-MM-dd")}</div>
                        </div>
                    </div>
                </li>
            </ul>
        </Box>
    );
}
export default withTranslate(En);